import { render, staticRenderFns } from "./Requeststatus.vue?vue&type=template&id=4974231b"
import script from "./Requeststatus.vue?vue&type=script&lang=js"
export * from "./Requeststatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports